import angular from "angular"

const app = angular.module("appModule")

// This one is defined by webpack's DefinePlugin
const BASE_URL = API_HOST

import "./api/user.service"

app.factory("GroupService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(
      apiService.apiUrl + "groups/:id/",
      { id: "@id" },
      {
        remove: {
          method: "DELETE",
          isArray: true
        }
      }
    )
  }
])

app.factory("SedeService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(apiService.apiUrl + "sedes/:sede/", { sede: "@sede" })
  }
])

app.factory("JornadaService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(apiService.apiUrl + "jornadas/:id/", { id: "@id" })
  }
])

app.factory("EscuelaService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(apiService.apiUrl + "escuelas/:id/", { id: "@id" })
  }
])

app.factory("CarreraService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(apiService.apiUrl + "carreras/:id/", { id: "@id" })
  }
])

app.factory("AlumnoService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(apiService.apiUrl + "alumnos/:alumno/", {
      alumno: "@alumno"
    })
  }
])

app.factory("EventoListService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(
      apiService.apiUrl + "eventos_list/:evento/",
      { evento: "@evento" },
      {
        query: {
          method: "GET",
          isArray: false
        }
      }
    )
  }
])

app.factory("EventoService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(
      apiService.apiUrl + "eventos/:evento/",
      { evento: "@evento" },
      {
        remove: {
          method: "DELETE",
          isArray: true
        },
        update: {
          method: "PATCH",
          isArray: true
        }
      }
    )
  }
])

app.factory("AlertaListService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(
      apiService.apiUrl + "alertas_list/:alerta/",
      { alerta: "@alerta" },
      {
        query: {
          method: "GET",
          isArray: false
        }
      }
    )
  }
])

app.factory("AlertaService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(
      apiService.apiUrl + "alertas/:alerta/",
      { alerta: "@alerta" },
      {
        remove: {
          method: "DELETE",
          isArray: true
        },
        update: {
          method: "PATCH",
          isArray: true
        }
      }
    )
  }
])

app.factory("TipoAlertaService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(
      apiService.apiUrl + "tipos_alerta/:id/",
      { id: "@id" },
      {
        remove: {
          method: "DELETE",
          isArray: true
        }
      }
    )
  }
])

app.factory("EstadoAlertaService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(apiService.apiUrl + "estados_alerta/:id/", { id: "@id" })
  }
])

app.factory("MatriculaService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(apiService.apiUrl + "matriculas/:id/", { id: "@id" })
  }
])

app.factory("EstadoMatriculaService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(apiService.apiUrl + "estados_matricula/:id/", {
      id: "@id"
    })
  }
])

app.factory("TareaService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(
      apiService.apiUrl + "tareas/:tarea/",
      { tarea: "@tarea" },
      {
        remove: {
          method: "DELETE",
          isArray: true
        }
      }
    )
  }
])

app.factory("PlanAccionService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(
      apiService.apiUrl + "planes_accion/:plan_accion/",
      { plan_accion: "@plan_accion" },
      {
        remove: {
          method: "DELETE",
          isArray: true
        }
      }
    )
  }
])

app.factory("CategoriaService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(
      apiService.apiUrl + "categorias/:id/",
      { id: "@id" },
      {
        remove: {
          method: "DELETE",
          isArray: true
        }
      }
    )
  }
])

app.factory("ComentarioService", [
  "apiService",
  "$resource",
  function(apiService, $resource) {
    return $resource(
      apiService.apiUrl + "comentarios/:id/",
      { id: "@id" },
      {
        remove: {
          method: "DELETE",
          isArray: true
        }
      }
    )
  }
])

app.factory("PeriodoService", [
  "$rootScope",
  "apiService",
  "$resource",
  "$http",
  "store",
  "$q",
  function($rootScope, apiService, $resource, $http, store, $q) {
    const Periodo = $resource(apiService.apiUrl + "periodos/:periodo_id/", {
      periodo_id: "@periodo_id"
    })
    Periodo.get_periodo_actual = function() {
      var periodo_activo = store.get("periodo_activo")
      if (!periodo_activo) {
        return $http({
          method: "GET",
          url: apiService.apiUrl + "periodos/?actual=1"
        }).then(function(response) {
          periodo_activo = response.data.results[0]
          store.set("periodo_activo", periodo_activo)
          return periodo_activo
        })
      } else {
        return $q.when(periodo_activo)
      }
    }

    Periodo.set_periodo_actual = function(periodo) {
      store.set("periodo_activo", periodo)
      $rootScope.$broadcast("periodoChange", periodo)
    }

    return Periodo
  }
])

app.service("apiService", [
  "$rootScope",
  "$http",
  function($rootScope, $http) {
    var self = this

    self.baseUrl = BASE_URL
    self.apiUrl = self.baseUrl + "api/"
    self.api_auth_url = "api-token-auth/"

    self.getMatriculas = function(params) {
      params["periodo_id"] = $rootScope.periodo_activo

      var cedula = null
      if (params["cedula"]) {
        cedula = params["cedula"]
        delete params["cedula"]
      }

      return $http({
        method: "POST",
        url: self.apiUrl + "matriculas_list/",
        params: params,
        data: { cedula: cedula }
      }).then(function(response) {
        return response.data
      })
    }

    self.getAlumnos = function(params) {
      params["periodo_id"] = $rootScope.periodo_activo

      return $http({
        method: "GET",
        url: self.apiUrl + "alumnos_list/",
        params: params
      }).then(function(response) {
        return response.data
      })
    }

    self.getAtenciones = function(params) {
      return $http({
        method: "GET",
        url: self.apiUrl + "atenciones/",
        params: params
      }).then(function(response) {
        return response.data
      })
    }

    return {
      getMatriculas: self.getMatriculas,
      getAlumnos: self.getAlumnos,
      getAtenciones: self.getAtenciones,
      baseUrl: self.baseUrl,
      apiUrl: self.apiUrl,
      api_auth_url: self.api_auth_url
    }
  }
])

app.service("ExportService", [
  "$rootScope",
  "$http",
  "$q",
  "apiService",
  "$window",
  function($rootScope, $http, $q, apiService, $window) {
    var self = this

    self.apiUrl = apiService.apiUrl

    self.reporteEstudiantesAtendidos = function() {
      return self.descargaReporte(self.apiUrl + "reporting/students/", "estudiantes.xlsx")
    }

    self.reporteAtencionesRealizadas = function() {
      return self.descargaReporte(self.apiUrl + "reporting/current_attentions/", "atenciones.xlsx")
    }

    self.reporteAlertasEnCurso = function() {
      return self.descargaReporte(self.apiUrl + "reporting/current_alerts/", "alertas.xlsx")
    }

    self.reporteUsuarios = function() {
      return self.descargaReporte(
        self.apiUrl + "reporting/responsible_users/",
        "reporte_usuarios.xlsx"
      )
    }

    self.descargaReporte = function(url, defaultFileName) {
      var self = this
      var deferred = $q.defer()
      $http
        .get(url, {
          responseType: "arraybuffer",
          params: {
            periodo_id: $rootScope.periodo_activo
          }
        })
        .then(
          function(response) {
            var data = response.data
            var status = response.status
            var headers = response.headers

            var type = headers("Content-Type")
            var disposition = headers("Content-Disposition")
            if (disposition) {
              var match = disposition.match(/.*filename=\"?([^;\"]+)\"?.*/)
              if (match[1]) defaultFileName = match[1]
            }
            defaultFileName = defaultFileName.replace(/[<>:"\/\\|?*]+/g, "_")
            deferred.resolve({
              filename: defaultFileName,
              data: data,
              type: type
            })
          },
          function(response) {
            var e /* error */ = deferred.reject(e)
          }
        )
      return deferred.promise
    }

    return {
      reporteEstudiantesAtendidos: self.reporteEstudiantesAtendidos,
      reporteAtencionesRealizadas: self.reporteAtencionesRealizadas,
      reporteAlertasEnCurso: self.reporteAlertasEnCurso,
      reporteUsuarios: self.reporteUsuarios
    }
  }
])

app.service("ImportService", [
  "$rootScope",
  "$http",
  "apiService",
  function($rootScope, $http, apiService) {
    var self = this

    self.apiUrl = apiService.apiUrl

    self.importAtenciones = function(data) {
      data["periodo_id"] = $rootScope.periodo_activo

      if (data.atributos !== undefined && data.atributos !== null && data.atributos !== "") {
        data.atributos = JSON.stringify(data.atributos)
      }

      return $http({
        method: "POST",
        url: self.apiUrl + "import_atenciones/",
        data: data
      }).then(function(response) {
        return response
      })
    }

    self.importAlertas = function(data) {
      data["periodo_id"] = $rootScope.periodo_activo

      if (data.atributos !== undefined && data.atributos !== null && data.atributos !== "") {
        data.atributos = JSON.stringify(data.atributos)
      }

      return $http({
        method: "POST",
        url: self.apiUrl + "import_alertas/",
        data: data
      }).then(function(response) {
        return response
      })
    }

    self.importEstadosMatricula = function(data) {
      data["periodo_id"] = $rootScope.periodo_activo

      if (data.atributos !== undefined && data.atributos !== null && data.atributos !== "") {
        data.atributos = JSON.stringify(data.atributos)
      }

      return $http({
        method: "PATCH",
        url: self.apiUrl + "import_estados_matricula/",
        data: data
      }).then(function(response) {
        return response
      })
    }

    return {
      importAtenciones: self.importAtenciones,
      importAlertas: self.importAlertas,
      importEstadosMatricula: self.importEstadosMatricula
    }
  }
])

app.service("statsService", [
  "$http",
  "apiService",
  "PeriodoService",
  function($http, apiService, PeriodoService) {
    var self = this

    self.apiUrl = apiService.apiUrl

    self.getStats = function(params) {
      // console.log("get Stats PARAMS:", params);

      return PeriodoService.get_periodo_actual().then(function(periodo_activo) {
        params["periodo_id"] = periodo_activo.id

        return $http({
          method: "GET",
          url: self.apiUrl + "stats/",
          params: params
        }).then(function(response) {
          return response.data
        })
      })
    }

    return {
      getStats: self.getStats
    }
  }
])

app.service("notificarService", [
  "$http",
  "apiService",
  function($http, apiService) {
    const { apiUrl } = apiService

    const notificar = params => {
      return $http({
        method: "POST",
        url: apiUrl + "notificar/",
        data: params
      }).then(function(response) {
        return response
      })
    }

    return {
      notificar
    }
  }
])
